if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        this.targetId = this.dataset.target;
        this.swiper   = document.getElementById(this.targetId);
        this.buttons  = Array.from(this.querySelectorAll('button'));

        // Init with first tab active
        const firstHandle = this.buttons[0]?.dataset.collection;
        if (firstHandle) this.toggleCollection(firstHandle);

        this.buttons.forEach(button => {
          button.addEventListener('click', e => {
            e.preventDefault();
            const handle = button.dataset.collection;
            this.buttons.forEach(b => b.classList.remove('active'));
            button.classList.add('active');
            if (handle) this.toggleCollection(handle);
          });
        });
      }, 100);
    }

    toggleCollection(handle) {
      if (!this.swiper) return;

      const allSlides = Array.from(this.swiper.querySelectorAll('.swiper-slide'));
      const swiperInstance = this.swiper.swiper;

      allSlides.forEach(slide => {
        const match = slide.dataset.collection === handle;

        if (swiperInstance) {
          // Slider mode: Swiper 11 skips slides with display:none on update()
          slide.style.display = match ? '' : 'none';
        } else {
          // Grid mode: toggle class, CSS handles display
          slide.classList.toggle('collection-tab__slide--hidden', !match);
        }
      });

      // Swap banner image
      const section = this.swiper.closest('[data-id]');
      if (section) {
        section.querySelectorAll('.collection-tab__image-wrapper').forEach(img => {
          img.style.display = img.dataset.collection === handle ? '' : 'none';
        });
      }

      // Recalculate Swiper after visibility change
      if (swiperInstance) {
        swiperInstance.update();
        swiperInstance.slideTo(0, 0);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
